<template>
    <div class="component">
        <vue-headful
                title="Edit theme | W&S Docs"
        />
        <div v-if="loading" class="loading">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="result" class="alert alert-secondary text-success font-weight-bold" role="alert">
            Превью успешно изменено!
        </div>
        <div class="form-group">
            <router-link class="btn bg-dark text-white" to="/admin/previews">Вернуться назад</router-link>
        </div>
        <div class="form">
            <div class="form-group">
                <label for="theme" class="">Выберите тему</label>
                <select id="theme" class="custom-select bg-dark text-white" v-model="theme">
                    <option disabled>Выберите тему</option>
                    <option v-for="(theme, index) in themes" :key="index" :value="theme.theme_id">{{theme.theme_title}}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label for="title">Введите название</label>
                <input id="title" type="text" class="form-control" placeholder="Введите название" v-model="title"/>
            </div>
            <div class="form-group">
                <label for="desc">Введите описание</label>
                <input id="desc" type="text" class="form-control" placeholder="Введите краткий адрес" v-model="desc"/>
            </div>
            <div class="form-group">
                <label for="link">Введите краткий адрес</label>
                <input id="link" type="text" class="form-control" placeholder="Введите краткий адрес" v-model="link"/>
                <small class="form-text text-muted">Например: user.get</small>
            </div>
            <div class="form-group">
                <VueTrix v-model="content" placeholder="Введите содержимое" id="text" localStorage />
            </div>
            <button class="btn btn-dark" id="submit_btn" v-on:click="EditTheme">Редактировать превью</button>

            <div class="method mt-4">
                Предпросмотр:
                <div class="container-fluid ">
                    <h2>{{ title }}</h2>
                    <p v-html="content">{{ content }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import VueTrix from "vue-trix";
    import axios from "axios";
    Vue.use(VueTrix);

    export default {
        name: "ThemeEdit",
        props: ['id'],
        components: {
            VueTrix,
        },
        data() {
            return {
                themes: [],
                preview_id: null,
                title: this.title,
                content: this.content,
                link: this.link,
                desc: this.desc,
                theme: this.theme,
                result: null,
                loading: true,
            };
        },
        methods: {
            EditTheme: function () {
                let params = new URLSearchParams();
                params.append("preview_id", this.preview_id);
                params.append("preview_title", this.title);
                params.append("preview_desc", this.desc);
                params.append("preview_link", this.link);
                params.append("preview_content", this.content);
                params.append("preview_theme", this.content);
                axios({
                    method: "post",
                    headers: {"Content-Type": "application/x-www-form-urlencoded"},
                    url: "https://api.write-and-share.ml/docs/preview.edit",
                    data: params,
                })
                    .then(
                        this.theme = this.title = this.content = this.link = this.desc = "",
                        this.result = true
                    )
            },

        },
        mounted() {
            this.loading = false;
            axios('https://api.write-and-share.ml/docs/preview.get?preview_link=' + this.id)
                .then(response => {
                    this.title = response.data.response[0].preview_title;
                    this.link = response.data.response[0].preview_link;
                    this.desc = response.data.response[0].preview_desc;
                    this.content = response.data.response[0].preview_content;
                    this.preview_id = response.data.response[0].preview_id;
                });
            axios('https://api.write-and-share.ml/docs/theme.get')
                .then(response => {
                    this.themes = response.data.response;
                    this.theme = response.data.response[0].theme_id;
                });
        },
    }
</script>

<style scoped>

</style>
